
import { client, getEnv } from 'config';
import { App } from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

export default function install(app:App):void{
  if (client && getEnv('VITE_RECAPTCHA_ENABLED') && getEnv('VITE_RECAPTCHA_CLIENT_KEY')) {
    app.use(VueReCaptcha, { siteKey: getEnv('VITE_RECAPTCHA_CLIENT_KEY') } as any)
  }
}
